import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";
import MentionsLegales from "./MentionsLegales";
const styles = require(`../../assets/css/style.jsx`).default;
class Footer extends React.Component {
  state = {
    mlIsOpen: false
  }

  handleCloseML = () => {
    this.setState({
      mlIsOpen: false
    })
  }

  render () {
    const appClient = process.env.REACT_APP_CLIENT
    const { classes, fluid, white } = this.props
    const { mlIsOpen } = this.state

    var container = cx({
      [classes.container]: !fluid,
      [classes.containerFluid]: fluid,
      [classes.whiteColor]: white
    });
    var anchor =
      classes.a +
      cx({
        [" " + classes.whiteColor]: white
      });
    var block = cx({
      [classes.block]: true,
      [classes.whiteColor]: white
    });

    return (
      <footer style={styles.footer}>
        <div className={container}>
          <div className={classes.left}>
            <List className={classes.list}>
              <ListItem className={classes.inlineBlock}>
                <a href={'/'+appClient+'/tutoriel.pdf'} rel='noreferrer noopener' target='_blank' className={block} style={styles.linkFooter}>
                  Tutoriel
                </a>
              </ListItem>

            </List>
          </div>
          <p className={classes.right}>
            &copy; {1900 + new Date().getYear()}{" "}
            <a className={anchor}>
              Sogec Digital
            </a>
            <MentionsLegales
              open={mlIsOpen}
              handleClose={this.handleCloseML}
            />
          </p>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx